export default "__VITE_ASSET__2fff5de6__"